import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Col, Row, Input} from "reactstrap";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import _ from "lodash";
import classnames from "classnames";
import Sortable from "react-sortablejs";
import QuestionContainer from "../Components/questionContainer";
import AnswerContainer from "../Components/answerContainer";
import ImageOpenAnswer from "../Components/imageOpenAnswer";

class Ranked extends Component {

  constructor(props){
    super(props);

    this.state = {
      editingContent: {
        index: false,
        content: ''
      },
      dragging: false
    };

    this.getPlacesCount = this.getPlacesCount.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
  }

  getPlacesCount(){
    return this.props.question.places || this.props.question.answers.length;
  }

  setDefaultEditingContent(){
    this.setState({
      editingContent: {
        index: false,
        content: '',
      }
    });
  }

  onInputBlur(content, index){
    let {details} = this.props;
    const microTime = getCurrentMicroTime(this.props.startTime);

    details[index] = {
      ...details[index],
      content,
      microTime,
    };

    this.props.onDetailsUpdated(details);

    this.setDefaultEditingContent();
  }

  removeDetail(index){
    this.setDefaultEditingContent();

    let {details} = this.props;
    delete details[index];
    details = details.filter(d => d);

    details = details.map((d, key) => {
      d.place = key+1;
      return d;
    });

    this.props.onDetailsUpdated(details);
  }

  addAnswerToDetail(index, indexTo = null){
    let {details, question} = this.props;
    const microTime = getCurrentMicroTime(this.props.startTime);

    if(details.length >= this.getPlacesCount() || Object.values(details).find(d => d.answer === question.answers[index].id)){
      return;
    }

    const detail = {
      answer: question.answers[index].id,
      place: indexTo ? indexTo + 1 : null,
      microTime,
    };

    if (indexTo != null) {
      let arrayClone = details.slice();
      arrayClone.splice(indexTo,0, detail);
      arrayClone = arrayClone.map((d,key) => {
        d.place = key + 1;
        return d;
      });

      details = arrayClone;
    } else {
      details.push(detail);
      details = details.map((d, key) => {
        d.place = key+1;
        return d;
      });
    }

    this.props.onDetailsUpdated(details);
  }

  updateDetailPosition(indexFrom, indexTo){
    let {details} = this.props;
    let detail = details[indexFrom];

    let arrayClone = details.slice();
    arrayClone.splice(indexFrom,1);
    arrayClone.splice(indexTo,0,detail);
    arrayClone = arrayClone.map((d,key) => {
      d.place = key + 1;
      return d;
    });

    this.props.onDetailsUpdated(arrayClone);
  }

  onOpenChange(e){
    const {question} = this.props;
    const answerId = parseInt(e.target.attributes['data-id'].nodeValue);
    const content = e.target.value;

    if(content !== '' && !!question.openRegex){
      const regex = new RegExp(question.openRegex, 'g');
      if(!regex.test(content)){
        return;
      }
    }

    const microTime = getCurrentMicroTime(this.props.startTime);

    const details = this.props.details.map(detail => {
      if(detail.answer === answerId){
        detail.microTime = microTime;
        detail.content = content;
      }

      return detail;
    });

    if(!details.find(detail => detail.answer === answerId)){
      const detail = {
        answer: answerId,
        microTime,
        content
      }

      details.push(detail);
    }

    this.props.onDetailsUpdated(details);
  }

  validate(){
    const {details, question, validationTexts} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    if(question.requiredCount > details.length && details.length < question.answers.length){
      validate.errors.push(validationTexts.requiredCount + (question.requiredCount > question.answers.length ? question.answers.length : question.requiredCount));
    }

    if (question.requiredAll) {
      const answersCount = question.answers.length;
      const places = this.getPlacesCount();

      if ((answersCount >= places && details.length < places) || (answersCount <= places && details.length < answersCount)) {
        validate.errors.push(validationTexts.requiredAll);
      }
    }

    Object.values(details).map(detail => {
      const answer = question.answers.find(a => a.id === detail.answer);

      if(answer && answer.isOpen && _.isEmpty(detail.content) && !answer.openIsNotRequired){
        validate.errors.push(validationTexts.detail.answerContentEmpty);
      }
    });

    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render() {
    const {question, details} = this.props;
    const {editingContent, dragging} = this.state;
    const places = this.getPlacesCount();

    let missingPlaces = [];
    for(let i = details.length; i < (places ? places : question.answers.length); i++){
      missingPlaces.push(<AnswerContainer
          classes={"d-list-item"}
          answer={{
            id: "empty-" + i,
            position: i
          }}
          component={
            <div className={"d-flex align-items-center h-100"}>
              <span className={"w-100"}>&nbsp;</span>
            </div>
          }
      />);
    }

    if (dragging && missingPlaces.length > 0) {
      missingPlaces.pop();
    }

    return (
      <QuestionContainer answersColumns={question.showVertically ? 1 : 2}
        component={
          <React.Fragment >
            <Col xs={12} className={"px-1 answers-to-add"}>
              <h3 className="mb-3 pl-1 validation-header">Wybierz kolejność odpowiedzi</h3>
              <Sortable
                  className="w-100 row mx-0 d-grid"
                  options={{
                    group: {
                      name: 'ranked-answers-' + question.id,
                    },
                    animation: 100,
                    delay: 100,
                    filter: '.not-active',
                    onStart: e => this.setState({dragging: question.answers[e.oldIndex].id}),
                    onEnd: () => this.setState({dragging: false}),
                  }}
              >
                {question.answers.map((answer, index) => {
                  let isSelected = !!Object.values(details).find(d => d.answer === answer.id);

                  return (
                      <AnswerContainer
                          answer={answer}
                          isNotActive={isSelected}
                          onClick={() => this.addAnswerToDetail(index)}
                          component={
                            <ImageOpenAnswer
                                answer={answer}
                                checkboxType={''}
                                answersImage={question.answersImage}
                                showContent={true}
                                answerOpenAlwaysShow={true}
                                rightComponent={isSelected ? <React.Fragment/> : <div className={classnames({
                                  "text-right img-icon": question.answersImage,
                                  "text-right mr-3 ml-3": !question.answersImage
                                })}>
                                  <i className="fas fa-circle-plus p-0"/>
                                </div>}
                            />
                          }
                      />
                  )
                })}
              </Sortable>
            </Col>
            <Col xs={12} className={"px-1 answers-to-delete"}>
              <h3 className="mb-3 pl-1 validation-header">Twoja kolejność</h3>
              <ol className="pl-0 ml-3 pl-1">
                <Sortable
                    className={classnames({
                      'pb-5': dragging,
                      'd-grid': true
                    })}
                    options={{
                      group: {
                        name: 'ranked-details-' + question.id,
                        put: ['ranked-answers-' + question.id],
                      },
                      animation: 100,
                      filter: '.trash, .empty-place'
                    }}
                    onChange={(order, sortable, evt) => {
                      if (evt.type === 'add') {
                        this.addAnswerToDetail(evt.oldIndex, evt.newIndex)
                      }
                      if (evt.type === 'update') {
                        this.updateDetailPosition(evt.oldIndex, evt.newIndex)
                      }
                    }}
                >
                  {details.map((detail, index) => {
                    const answer = question.answers.find(a => a.id === detail.answer);
                    const checked = detail && parseInt(detail.answer) === answer.id;

                    return (
                          <AnswerContainer
                            classes={"d-list-item"}
                            checked={checked}
                            answer={answer}
                            component={
                              <ImageOpenAnswer
                                  answer={answer}
                                  detail={detail}
                                  checked={checked}
                                  checkboxType={''}
                                  answersImage={question.answersImage}
                                  showInput={(answer.isOpen && checked)}
                                  showContent={(answer.isOpen && checked) === false}
                                  onBlur={(e) => this.onInputBlur(e.target.value, index)}
                                  answerOpenAlwaysShow={true}
                                  onOpenChange={this.onOpenChange}
                                  rightComponent={<div  className={classnames({
                                    "text-right img-icon": question.answersImage,
                                    "text-right mr-2 ml-2": !question.answersImage && !answer.isOpen,
                                    "pl-3": !question.answersImage && answer.isOpen
                                  })} onClick={() => this.removeDetail(index)}>
                                    <i className="pointer fas fa-circle-minus pr-3"/>
                                  </div>}
                              />
                            }
                        />
                    )
                  })}
                  {missingPlaces && missingPlaces}
                </Sortable>
              </ol>
            </Col>
          </React.Fragment>
        } />
    );
  }
}

Ranked.propTypes = {
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
      openIsNotRequired: PropTypes.bool.isRequired,
    }),).isRequired,
    places: PropTypes.number.isRequired,
    answersColumns: PropTypes.number.isRequired,
    showVertically: PropTypes.bool.isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    place: PropTypes.number.isRequired,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  // validationTexts: PropTypes.shape({}).isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(Ranked);